<template>
  <div class="mt-4 p-3 border rounded-4 bg-light">
    <h4 class="mb-3">Configuración BDP</h4>
    <div class="mb-3">
      <label for="login" class="form-label">Login:<span class="text-danger">*</span></label>
      <input
        id="login"
        type="text"
        class="form-control"
        v-model="localLogin"
        @input="onLoginChange"
        maxlength="50"
        placeholder="Ej: usuario123" />
    </div>
    <div class="mb-3">
      <label for="password" class="form-label">Password:<span class="text-danger">*</span></label>
      <input
        id="password"
        type="password"
        class="form-control"
        v-model="localPassword"
        @input="onPasswordChange"
        maxlength="50"
        placeholder="********" />
    </div>
    <div class="mb-3">
      <label for="integratorCode" class="form-label">Integrator Code:<span class="text-danger">*</span></label>
      <input
        id="integratorCode"
        type="text"
        class="form-control"
        v-model="localIntegratorCode"
        @input="onIntegratorCodeChange"
        maxlength="50"
        placeholder="Ej: INT-0001" />
    </div>
    <div class="mb-3">
      <label for="localUrl" class="form-label">Local URL:</label>
      <input
        id="localUrl"
        type="url"
        class="form-control"
        v-model="localLocalUrl"
        @input="onLocalUrlChange"
        maxlength="200"
        placeholder="Ej: https://miurl.local" />
    </div>
  </div>
</template>

<script>
    export default {
    name: 'FormBDPComponent',
    props: {
        login: { type: String, default: '' },
        password: { type: String, default: '' },
        integratorCode: { type: String, default: '' },
        localUrl: { type: String, default: '' }
    },
    data() {
        return {
            localLogin: this.login,
            localPassword: this.password,
            localIntegratorCode: this.integratorCode,
            localLocalUrl: this.localUrl
        };
    },
    watch: {
        login(val) {
            this.localLogin = val;
        },
        password(val) {
            this.localPassword = val;
        },
        integratorCode(val) {
            this.localIntegratorCode = val;
        },
        localUrl(val) {
            this.localLocalUrl = val;
        }
    },
    methods: {
        onLoginChange() {
            this.$emit('update:login', this.localLogin);
        },
        onPasswordChange() {
            this.$emit('update:password', this.localPassword);
        },
        onIntegratorCodeChange() {
            this.$emit('update:integratorCode', this.localIntegratorCode);
        },
        onLocalUrlChange() {
            this.$emit('update:localUrl', this.localLocalUrl);
        }
    }
    };
</script>

<style scoped>
</style>
